import React from 'react';
import VimeoEmbed from '../../Shared/VimeoEmbed'
import styles from './Testimonials.module.scss';

const Testimonial = (props) => (
  <div id={ props.id } className={styles.Story} style={ props.style }>
    <div className={styles.Story__Wrapper}>

      <div className={`${styles.StoryItem} ${styles.StoryItemTwo}`}>
        <div className={styles.StoryItemTwo__Left}>
          <div>
            <img className="profile-image" src={props.testimonials.profileImage.file.url} alt={props.testimonials.profileImage.title} />
            <h3 dangerouslySetInnerHTML={{ __html: props.testimonials.title }}></h3>
          </div>
        </div>
        <div className={styles.StoryItemTwo__Right}>
          <p className="animated">{props.testimonials.quote}</p>
          {
              props.testimonials.videoLink &&
              <VimeoEmbed
                url={props.testimonials.videoLink}
                poster={ props.testimonials.videoPosterImage ? props.testimonials.videoPosterImage : '' }
                loop={false}
                autoplay={false}
                controls={true}
              />
          }
        </div>
      </div>

    </div>
  </div>
)

export default Testimonial;



// WEBPACK FOOTER //
// ./src/components/WhatAboutCollege/Testimonial/index.js